import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { ReactComponent as CamelIcon } from '../assets/logo/camel-svgrepo-com.svg';
import { ReactComponent as GoatIcon } from '../assets/logo/capricorn-svgrepo-com.svg';
import { ReactComponent as CattleIcon } from '../assets/logo/cow-silhouette-svgrepo-com.svg';
import { ReactComponent as DonkeyIcon } from '../assets/logo/donkey-svgrepo-com.svg';
import { ReactComponent as TankersIcon } from '../assets/logo/water-truck-svgrepo-com.svg';
import { ReactComponent as BoreholesIcon } from '../assets/logo/vintage-water-pump-svgrepo-com.svg';
import { ReactComponent as FamilyIcon } from '../assets/logo/family-svgrepo-com.svg';
import {Avatar, Stack, Typography, Grid, ImageList, ImageListItem, ImageListItemBar} from '@mui/material';
import { blue, red, green } from '@mui/material/colors';
import CountUp from 'react-countup';
import RegisteredBHImage from './RegisteredBHImage';

const PopupTabs = ({ props }) => {
  const [activeTab, setActiveTab] = useState('general');
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const itemData = [
        {
            img: 'https://images.unsplash.com/photo-1549388604-817d15aa0110',
            title: 'Bed',
            author: 'swabdesign',
        },
        {
            img: 'https://images.unsplash.com/photo-1525097487452-6278ff080c31',
            title: 'Books',
            author: 'Pavel Nekoranec',
        },
        {
            img: 'https://images.unsplash.com/photo-1523413651479-597eb2da0ad6',
            title: 'Sink',
            author: 'Charles Deluvio',
        },
        {
            img: 'https://images.unsplash.com/photo-1563298723-dcfebaa392e3',
            title: 'Kitchen',
            author: 'Christian Mackie',
        },
        {
            img: 'https://images.unsplash.com/photo-1588436706487-9d55d73a39e3',
            title: 'Blinds',
            author: 'Darren Richardson',
        },
        {
            img: 'https://images.unsplash.com/photo-1574180045827-681f8a1a9622',
            title: 'Chairs',
            author: 'Taylor Simpson',
        },
        {
            img: 'https://images.unsplash.com/photo-1530731141654-5993c3016c77',
            title: 'Laptop',
            author: 'Ben Kolde',
        },
        {
            img: 'https://images.unsplash.com/photo-1481277542470-605612bd2d61',
            title: 'Doors',
            author: 'Philipp Berndt',
        },
        {
            img: 'https://images.unsplash.com/photo-1517487881594-2787fef5ebf7',
            title: 'Coffee',
            author: 'Jen P.',
        },
        {
            img: 'https://images.unsplash.com/photo-1516455207990-7a41ce80f7ee',
            title: 'Storage',
            author: 'Douglas Sheppard',
        },
        {
            img: 'https://images.unsplash.com/photo-1597262975002-c5c3b14bbd62',
            title: 'Candle',
            author: 'Fi Bell',
        },
        {
            img: 'https://images.unsplash.com/photo-1519710164239-da123dc03ef4',
            title: 'Coffee table',
            author: 'Hutomo Abrianto',
        },
    ];

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    return d.toLocaleDateString('en-GB', {
      day: 'numeric', month: 'short', year: 'numeric'
    });
  };

  const insightItem = [
    { color: blue[500], value: props.tot_household, Icon: FamilyIcon },
    { color: blue[500], value: props.camel_tot, Icon: CamelIcon },
    { color: blue[500], value: props.sheep_tot, Icon: GoatIcon },
    { color: blue[500], value: props.cattle_tot, Icon: CattleIcon },
    { color: blue[500], value: props.donkey_tot, Icon: DonkeyIcon },
    { color: blue[500], value: props.tankers_tot, Icon: TankersIcon },
    // …add as many as you like
    ];

  return (
    <div style={{ fontFamily: "'Segoe UI', Arial, sans-serif", minWidth: 240 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 7 }}>
        <span style={{
          fontWeight: 'bold', fontSize: '1.08em', display: 'inline-block', padding: '2px 8px',
          borderRadius: 3, color: '#fff',
          background: props.status === 'Functional' ? '#4caf50'
            : props.status === 'Not Functional' ? '#f44336'
            : '#607d8b'
        }}>
          {props.borehole_name || 'Unknown'}
        </span>
        <span style={{ fontSize: '0.93em', color: '#888', fontWeight: 400, marginLeft: 10, display: 'flex', flexDirection: 'column' }}>
          <span style={{fontSize: '7pt', alignSelf:'flex-end'}}>Last Update</span>
          <span>{props.last_update ? `${formatDate(props.last_update)}` : ''}</span>
        </span>
      </div>
        <div style={{ 
            borderBottom: '1px solid #eee', 
            marginBottom: 5,
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            display: 'flex' 
        }}>
            <Tabs
                sx={{
                    '& .MuiTabs-indicator': {
                        bottom: 2, 
                        height: 3, 
                    },
                    '& .MuiTabScrollButton-root': {
                        width:15,
                    },
                    '& .MuiTab-root': {
                        paddingLeft:1,
                        paddingRight:1,
                        fontSize:12 
                    },
                    minHeight:40,
                    height:40
                }}
                onChange={handleChange}
                value={activeTab}
                aria-label="Tabs where each tab needs to be selected manually"
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile>

                <Tab label="General" value={'general'}/>
                {/* <Tab label="Capacity"  value={'capacity'} /> */}
                <Tab label="Water Quality"  value={'quality'}/>
                <Tab label="Insights"  value={'insights'}/>
                <Tab label="Gallery"  value={'photo'}/>
                
            </Tabs>
        </div>
      {activeTab === 'general' && (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.96em' }}>
          <tbody>
            <tr>
              <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Region :</td>
              <td style={{ fontWeight: 500 }}>{props.region || '-'}</td>
            </tr>
            <tr>
              <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>District :</td>
              <td style={{ fontWeight: 500 }}>{props.district || '-'}</td>
            </tr>
            <tr>
              <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Settlement :</td>
              <td style={{ fontWeight: 500 }}>{props.settlement || '-'}</td>
            </tr>
            <tr style={{borderBottom: '1px solid #eee', marginBottom: 5}}>
              <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Agency :</td>
              <td style={{ fontWeight: 500 }}>{props.agency || '-'}</td>
            </tr>
            <tr>
                <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Borehole Depth :</td>
                <td style={{ fontWeight: 500 }}>{typeof props.bh_depth_m === 'number'
                    ? `${props.bh_depth_m.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} meters`
                    : '-'}
                </td>
            </tr>
            <tr>
                <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Water Level :</td>
                <td style={{ fontWeight: 500 }}>{typeof props.static_water_level_m === 'number'
                    ? `${props.static_water_level_m.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} meters`
                    : '-'}
                </td>
            </tr>
            <tr>
                <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Pump Level :</td>
                <td style={{ fontWeight: 500 }}>{typeof props.pump_setting === 'number'
                    ? `${props.pump_setting.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} meters`
                    : '-'}
                </td>
            </tr>
            <tr>
                <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Tank Capacity :</td>
                <td style={{ fontWeight: 500 }}>{typeof props.tank_capacity === 'number'
                    ? `${props.tank_capacity.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} L`
                    : '-'}
                </td>
            </tr>
            {props.is_broken && (
              <tr>
                <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Notes :</td>
                <td style={{ fontWeight: 500 }}>{typeof props.tank_capacity === 'number'
                    ? `Last known functional ${formatDate(props.broken_info.prev_status_date)}`
                    : '-'}
                </td>
            </tr>
            )}
            {props.is_fixed && (
              <tr>
                <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Notes :</td>
                <td style={{ fontWeight: 500 }}>{typeof props.tank_capacity === 'number'
                    ? `Last known broken ${formatDate(props.fixed_info.prev_status_date)}`
                    : '-'}
                </td>
            </tr>
            )}
            {props.is_longBroken && (
              <tr>
                <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Notes :</td>
                <td style={{ fontWeight: 500 }}>{typeof props.tank_capacity === 'number'
                    ? `Broken since ${formatDate(props.longBroken_info.broken_since)}`
                    : '-'}
                </td>
            </tr>
            )}
          </tbody>
        </table>
      )}
      {activeTab === 'quality' && (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.96em' }}>
          <tbody>
            <tr>
                <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>pH :</td>
                <td style={{ fontWeight: 500 }}>{typeof props.ph === 'number'
                    ? `${props.ph.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`
                    : '-'}
                </td>
            </tr>
            <tr>
              <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Conductivity:</td>
              <td style={{ fontWeight: 500 }}>{typeof props.ec_scm === 'number'
                    ? `${props.ec_scm.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} µS/cm`
                    : '-'}
                </td>
            </tr>
            <tr>
                <td style={{ color: '#888', padding: '2px 8px 2px 0', verticalAlign:'baseline' }}>Quality:</td>
                <td style={{ fontWeight: 500 }}>
                    {Array.isArray(props.noticeable_water_quality_reason) && props.noticeable_water_quality_reason.length > 0 ? (
                    <ul style={{ margin: 0, paddingLeft: '1em' }}>
                        {props.noticeable_water_quality_reason.map((reason, i) => {
                        // Take only before "__" and replace _ with space
                        const display = reason.split('__')[0].replace(/_/g, ' ');
                        return <li key={i}>{display}</li>;
                        })}
                    </ul>
                    ) : (
                    '-'
                    )}
                </td>
            </tr>
          </tbody>
        </table>
      )}
      {activeTab === 'insights' && (
        <Grid container spacing={2} columns={12 /* default */}>
            {insightItem.map(({ color, value, Icon }, idx) => (
                <Grid item xs={4} key={idx} width={85}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Avatar sx={{ bgcolor: color, width: 30, height: 30 }}>
                        <Icon style={{ fill: 'white', width: 24, height: 24 }} />
                        </Avatar>
                        <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                            <CountUp
                                // start={1}
                                end={value}
                                duration={1.2}
                                separator=","
                            />
                        </Typography>
                    </Stack>
                </Grid>
            ))}
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.96em' }}>
          <tbody>
            <tr>
                <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Avg. Yield:</td>
                <td style={{ fontWeight: 500 }}>{typeof props.yield_barrel === 'number'
                    ? `${props.yield_barrel.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} barrel`
                    : '-'}
                </td>
            </tr>
            <tr>
              <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Avg. water price:</td>
              <td style={{ fontWeight: 500 }}>{typeof props.water_price_barel === 'number'
                    ? `$${props.water_price_barel.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`
                    : '-'}
                </td>
            </tr>
            <tr>
              <td style={{ color: '#888', padding: '2px 8px 2px 0' }}>Avg. pumping hours:</td>
              <td style={{ fontWeight: 500 }}>{typeof props.pumping_hours === 'number'
                    ? `${props.pumping_hours.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} hour(s)`
                    : '-'}
                </td>
            </tr>
          </tbody>
        </table>
        </Grid>
      )}
      {activeTab === 'photo' && (
        <Grid container spacing={2}>
            {/* other grid items … */}

            <Grid item xs={12}>
                {/* scrollable wrapper */}
                <Box
                sx={{
                    height: 200,            // -- fixed viewport height
                    overflowY: 'auto',      // -- show scrollbar when content exceeds 400 px
                    pr: 1,                  // optional: space for scrollbar so chips don’t hide
                }}
                >
                  <RegisteredBHImage attachments={props.reg_attachments}/>
                </Box>
            </Grid>
            </Grid>
      )}
    </div>
  );
};

export default PopupTabs;